var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSummarize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15764_3687",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15764_3687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.33073 10.8331H12.1641C12.4002 10.8331 12.5981 10.7532 12.7578 10.5935C12.9175 10.4338 12.9974 10.2359 12.9974 9.99977C12.9974 9.76365 12.9175 9.56574 12.7578 9.40602C12.5981 9.24629 12.4002 9.16643 12.1641 9.16643H6.33073C6.09462 9.16643 5.8967 9.24629 5.73698 9.40602C5.57726 9.56574 5.4974 9.76365 5.4974 9.99977C5.4974 10.2359 5.57726 10.4338 5.73698 10.5935C5.8967 10.7532 6.09462 10.8331 6.33073 10.8331ZM6.33073 8.3331H12.1641C12.4002 8.3331 12.5981 8.25324 12.7578 8.09352C12.9175 7.93379 12.9974 7.73588 12.9974 7.49977C12.9974 7.26365 12.9175 7.06574 12.7578 6.90602C12.5981 6.74629 12.4002 6.66643 12.1641 6.66643H6.33073C6.09462 6.66643 5.8967 6.74629 5.73698 6.90602C5.57726 7.06574 5.4974 7.26365 5.4974 7.49977C5.4974 7.73588 5.57726 7.93379 5.73698 8.09352C5.8967 8.25324 6.09462 8.3331 6.33073 8.3331ZM3.83073 16.6664C3.3724 16.6664 2.98003 16.5032 2.65365 16.1768C2.32726 15.8505 2.16406 15.4581 2.16406 14.9998V4.99977C2.16406 4.54143 2.32726 4.14907 2.65365 3.82268C2.98003 3.49629 3.3724 3.3331 3.83073 3.3331H17.1641C17.6224 3.3331 18.0148 3.49629 18.3411 3.82268C18.6675 4.14907 18.8307 4.54143 18.8307 4.99977V14.9998C18.8307 15.4581 18.6675 15.8505 18.3411 16.1768C18.0148 16.5032 17.6224 16.6664 17.1641 16.6664H3.83073ZM3.83073 14.9998H17.1641V4.99977H3.83073V14.9998Z",
    fill: "#98A2B3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummarize);
export default __webpack_public_path__ + "static/media/summarize.b58888c58ab5a01c515b60f9ef5c1e43.svg";
export { ForwardRef as ReactComponent };